import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import pricing from '../locales/pricing';
import greeting from '../locales/greeting';
import landing from '../locales/landing';

const resources = {
    en: {
        translation: {
            ...pricing.en,
            ...greeting.en,
            ...landing.en,
            'Поддержка': 'Support',
            'Тарифы': 'Pricing',
            'Отзывы': 'Reviews',
            'Контакты': 'Contacts',
            'Блог': 'Blog',
            'EN': 'RU',
            'Партнерская программа': 'Affiliate Program',
            'Пользовательское соглашение': 'User agreement',
            'Политика конфиденциальности': 'Privacy policy',
            'Оферта': 'The offer',
            'Приложения': 'Apps',
            'Инструкция': 'Instruction',
            'Личный кабинет': 'Personal Account',
            'Пополняйте счёт и следите за подписками ваших ботов': 'Top up your balance and manage your bot subscriptions.',
            'счёт': 'account balance',
            'Последнее обновление': 'Last update',
            'Тариф': 'Tariff',
            'Стоимость в месяц': 'Cost per month',
            'Максимум приложений': 'Maximum applications',
            'Бесплатный': 'Free',
            'конструктор': 'constructor',
            'Войти через телеграм': 'Login via telegram',
            'Авторизуйтесь через TELEGRAM': 'Login via TELEGRAM',
            'Войти через Telegram': 'Login via Telegram',
            'Авторизуйтесь через телеграм': 'Login via telegram',
            'Войти': 'Login',
            'Создай приложение без единой строчки кода': 'Create application without any code',
            'Прокачай свой бизнес': 'Boost your business',
            'Сделай свое первое приложение': 'Make you first mini app',
            'бесплатно': 'for free',
            'Пополнить': 'Top up',
            'Изменено': 'Last edited',
            'Последнее редактирование:': 'Last edited:',
            'Всего приложений:': 'Total apps:',
            'Поиск': 'Search',
            'назад в': 'ago at',
            'Сегодня в': 'Today at',
            'Вчера в': 'Yesterday at',
            'Мои': 'My',
            'Создание нового': 'Creating new',
            'Создайте свой первый': 'Create your first',
            'не найдены': 'not found',
            'Мини-приложения не найдены': 'Mini apps not found',
            'Создай свое первое мини-приложение.': 'Create your first mini app.',
            'Создать мини-приложение': 'Create Mini App',
            'план': 'plan',
            planMessage: 'You have {{projectsLength}}/{{maxApps}} Mini Apps left',
            'Обновите, чтобы создать больше': 'Upgrade to create more',
            'Каталог': 'Catalog',
            'Форма': 'Form',
            'Кастом': 'Custom',
            'Ошибка создания Mini App': 'Creating Mini App error',
            'Выберите шаблон для начала': 'Choose template for start',
            'Создайте Web App-магазин': 'Create a Web App store',
            'Без шаблона': 'Without template',
            'Создать пустое приложение': 'Create empty app',
            'Создайте пустое приложение.': 'Create an empty app.',
            'каталог': 'catalog',
            'Введите название мини-приложения': 'Enter the mini app name',
            'Далее': 'Next',
            'Создайте Web App-магазин: каталог, заказы, оплата и аналитика — без кода.': 'Create a Web App store: catalog, orders, payments and analytics — no code.',
            'Каталог товаров': 'Catalog of products',
            'Форма обратной связи': 'Feedback form',
            'Выбран шаблон': 'Selected template',
            'Название приложения': 'App name',
            'Токен бота': 'Bot token',
            'Назад к выбору шаблона': 'Back to the template selection',
            'Создание...': 'Creating...',
            'Создать': 'Create',
            text: 'Text',
            input: 'Input',
            button: 'Button',
            image: 'Image',
            select: 'Select',
            datetime: 'Datetime',
            product: 'Product',
            form: 'Form',
            radiobutton: 'Radiobutton',
            checkbox: 'Checkbox',
            products: 'Products',
            container: 'Container',
            'Добавить': 'Add',
            'Вы ещё не добавили ни одного товара': 'You haven\'t added any products yet',
            'Добавьте первый товар, чтобы начать работу с приложением.': 'Add your first product to start working with the app.',
            'Настройки экрана': 'Screen settings',
            'Кнопка': 'Button',
            'Введите текст': 'Enter text',
            'Выбор': 'Select',
            'Выберите дату и/или время': 'Choose date and/or time',
            'Название товара': 'Product name',
            'Способ отображения': 'Display method',
            'Вертикально': 'Vertical',
            'Горизонтально': 'Horizontal',
            'Купить': 'Buy',
            'Добавить элемент': 'Add element',
            'Отправить': 'Send',
            'Добавить продукт': 'Add product',
            'Редактировать': 'Edit',
            'Сделать копию': 'Make a copy',
            'Копировать экран': 'Copy screen',
            'копия': 'copy',
            'Удалить': 'Delete',
            'Отмена': 'Cancel',
            'Удалить элемент?': 'Delete element?',
            'Удалить элемент формы?': 'Delete form element?',
            'Вы действительно хотите удалить этот элемент? Это действие необратимо.': 'Are you sure you want to delete this element? This action is irreversible.',
            'Вы действительно хотите удалить этот элемент формы? Это действие необратимо.': 'Are you sure you want to delete this form element? This action is irreversible.',
            'Экран не найден': 'Screen not found',
            'Без названия': 'Untitled',
            'Название экрана': 'Screen name',
            'Название проекта': 'Project name',
            'Сохранить': 'Save',
            'Проект': 'Project',
            'Экран': 'Screen',
            'Текущий экран не найден': 'Current screen not found',
            'Закрыть': 'Close',
            'Удалить опцию?': 'Delete option?',
            'Вы действительно хотите удалить эту опцию? Это действие необратимо.': 'Are you sure you want to delete this option? This action is irreversible.',
            'Добавить опцию': 'Add option',
            'Обязательное поле': 'Required field',
            'Текст кнопки': 'Button text',
            'Тип действия': 'Action type',
            'Перейти на экран': 'Navigate to screen',
            'Заполнить из Telegram': 'Fill from Telegram',
            'Целевой экран': 'Target screen',
            'Поле для {{name}}': 'Field for {{name}}',
            'Не заполнять': 'Do not fill',
            'User ID': 'User ID',
            'Username': 'Username',
            'Имя': 'First name',
            'Фамилия': 'Last name',
            'Язык': 'Language',
            'Премиум': 'Premium',
            'Нет данных Telegram': 'No Telegram data',
            'Метка': 'Label',
            'Подсказка': 'Placeholder',
            'Тип ввода': 'Input type',
            'Текст': 'Text',
            'Число': 'Number',
            'Пароль': 'Password',
            'Телефон': 'Phone',
            'Многострочный': 'Multiline',
            'Источник': 'Source',
            'Локальное хранилище': 'Local storage',
            'Внешний источник': 'External source',
            'Выбрать файл': 'Choose file',
            'В разработке': 'In progress',
            'URL изображения': 'Image URL',
            'Альтернативный текст': 'Alt text',
            'Описание': 'Description',
            'Цена': 'Price',
            'Валюта': 'Currency',
            'Режим': 'Mode',
            'Дата': 'Date',
            'Время': 'Time',
            'Название формы': 'Form title',
            'После отправки формы': 'After submitting the form',
            'Название': 'Title',
            'Расположение': 'Layout',
            'Вертикальное': 'Vertical',
            'Горизонтальное': 'Horizontal',
            'Неизвестный тип элемента': 'Unknown element type',
            'Контент': 'Content',
            'Стили': 'Styles',
            'Опция': 'Option',
            'Цвета': 'Colors',
            'Цвет текста': 'Text color',
            'Фон': 'Background',
            'Размеры': 'Sizes',
            'Ширина': 'Width',
            'Высота': 'Height',
            'Ед. изм.': 'Units',
            'Выравнивание элементов по горизонтали': 'Horizontal alignment',
            'Отступы': 'Spacing',
            'Отступ внутри (padding)': 'Inner spacing (padding)',
            'Раздельно по сторонам': 'Separate by sides',
            'Отступ (padding)': 'Padding',
            'Отступ снаружи (margin)': 'Outer spacing (margin)',
            'Отступ (margin)': 'Margin',
            'Границы': 'Borders',
            'Скругление границ': 'Border radius',
            'Раздельно по углам': 'Separate by corners',
            'Скругление': 'Border radius value',
            'ВЛ': 'TL',
            'ВП': 'TR',
            'НЛ': 'BL',
            'НП': 'BR',
            'Padding': 'Padding',
            'Margin': 'Margin',
            'BorderRadius': 'BorderRadius',
            'Удалить экран': 'Delete screen',
            'Шаблоны': 'Templates',
            'Бот': 'Bot',
            'Перейти в бота': 'Open bot',
            'Открыть WebApp': 'Open WebApp',
            'Создать экран': 'Create screen',
            'Настройки проекта': 'Project settings',
            'Предварительный просмотр': 'Preview',
            'Введите корректный email': 'Enter a valid email',
            'Введите число': 'Enter a number',
            'Введите корректный номер телефона': 'Enter a valid phone number',
            'Введите корректный URL': 'Enter a valid URL',
            'Это поле обязательно': 'Required field',
            'Выберите вариант': 'Select an option',
            'Выберите хотя бы один вариант': 'Select at least one option',
            'Выберите дату/время': 'Select date/time',
            'Заголовок 1': 'Heading 1',
            'Заголовок 2': 'Heading 2',
            'Обычный': 'Normal',
            'Размер': 'Size',
            'Сохранить форму': 'Save form',
            'Есть несохраненные изменения формы': 'There are unsaved form changes',
            'Сначала сохраните форму или отмените изменения.': 'Save the form or discard changes first.',
            'Не сохранять': 'Discard',
            'Удалить экран?': 'Delete screen?',
            'Вы действительно хотите удалить экран? Это действие необратимо.': 'Are you sure you want to delete this screen? This action is irreversible.',
            'Аналитика проекта': 'Project analytics',
            'Экспорт CSV': 'Export CSV',
            'Обновить': 'Refresh',
            'События': 'Events',
            'Отправки форм': 'Form submissions',
            'Данные заявки': 'Submission data',
            'Тип события': 'Event type',
            'Дата и время': 'Date and time',
            'Сессия': 'Session',
            'Свойства': 'Properties',
            'Элемент': 'Element',
            'К редактору': 'To editor',
            'Нет данных': 'No data',
            'Настройка экранов': 'Screen settings',
            'Лимит': 'Limit',
            'Назад': 'Back',
            'Вперёд': 'Next',
            'Версия': 'Version',
            'Период': 'Period',
            'За всё время': 'All time',
            'Последние 7 дней': 'Last 7 days',
            'Последние 30 дней': 'Last 30 days',
            'Текущий месяц': 'Current month',
            'Прошлый месяц': 'Last month',
            'Произвольный период': 'Custom period',
            'Сегодня': 'Today',
            'Вчера': 'Yesterday',
            'От': 'From',
            'До': 'To',
            APP_OPEN: 'App open',
            SCREEN_VIEW: 'Screen view',
            BUTTON_CLICK: 'Button click',
            FORM_SUBMIT: 'Form submit',
            'Невозможно удалить экран': 'Unable to delete the screen',
            'В проекте должен остаться хотя бы один экран': 'At least one screen must remain in the project',
            'Ок': 'Ok',
            'Введите токен бота': 'Enter bot token',
            'Для клонирования проекта требуется токен бота.': 'A bot token is required to clone the project.',
            'Клонировать': 'Clone',
            'Неверный формат токена бота': 'Invalid bot token format',
            'Формат: 123456789:AA...': 'Format: 123456789:AA...',
            'Токен не прошёл проверку на сервере': 'The token did not pass server validation',
            'Аналитика': 'Analytics',
            'Экраны': 'Screens',
            'Введите название нового экрана': 'Enter the name of the new screen',
            'Новый экран': 'New screen',
            'Инструкция по использованию': 'User guide',
            'Платформа позволяет создавать мини-приложения для Telegram без сохранения языков программирования.': 'The platform allows you to create mini apps for Telegram without learning programming languages.',
            'Вы можете начать с готового шаблона, настроить экраны под задачу и развернуть приложение за пару кликов.': 'You can start with a ready-made template, configure screens for your task, and deploy the app in a couple of clicks.',
            'Пройдите все шаги и разверните проект быстро и безопасно': 'Pass all steps and deploy the project quickly and securely',
            'О сервисе': 'About the service',
            'Авторизация через Telegram': 'Authorization via Telegram',
            'Готовые шаблоны и темы': 'Ready-made templates and themes',
            'Быстрое развертывание': 'Quick deployment',
            'Быстрый старт': 'Quick start',
            'Быстрый старт и редактор экранов': 'Quick start and screen editor',
            'Создайте проект:': 'Create a project:',
            'нажмите «Создать приложение».': 'click "Create Mini App".',
            'Проекты и шаблоны': 'Projects and templates',
            'Редактор экранов': 'Screen editor',
            'Аналитика Mini App': 'Mini App analytics',
            'Частые вопросы': 'FAQ',
            'Платформа позволяет создавать Mini App для Telegram без глубоких знаний программирования. Вы можете начать с готового шаблона, настроить экраны под задачу и развернуть приложение в пару кликов.': 'The platform allows you to create Mini Apps for Telegram without deep programming knowledge. You can start with a ready-made template, customize screens for your task, and deploy the app in a couple of clicks.',
            'Подключение происходит через ваш Telegram‑аккаунт. Авторизация безопасна и занимает пару секунд.': 'Connection occurs through your Telegram account. Authorization is secure and takes a few seconds.',
            'Авторизуйтесь через Telegram': 'Log in via Telegram',
            'Создайте проект: перейдите на страницу': 'Create a project: go to the',
            'Мои проекты': 'My projects',
            'и нажмите «Создать приложение».': 'and click "Create Mini App".',
            'Выберите шаблон или начните с пустого проекта.': 'Choose a template or start with an empty project.',
            'Отредактируйте экраны, тексты и действия в редакторе.': 'Edit screens, texts, and actions in the editor.',
            'Посмотрите проект перейдя в бота': 'View the project by going to the bot',
            'В разделе «Проекты» вы управляете своими приложениями: создаёте новые, открываете редактор, просматриваете статистику.': 'In the "Projects" section, you manage your apps: create new ones, open the editor, view statistics.',
            'Шаблоны ускоряют старт.': 'Templates speed up the start.',
            'Редактор позволяет настраивать структуру и внешний вид Mini App:': 'The editor allows you to customize the structure and appearance of the Mini App:',
            'Навигация по экранам: добавление, удаление, порядок.': 'Navigation across screens: add, delete, order.',
            'Компоненты: текст, изображения, кнопки, действия (переходы, открытие ссылок и др.).': 'Components: text, images, buttons, actions (navigation, open links, etc.).',
            'Темы и стили: базовые цвета, фон, типографика.': 'Themes and styles: base colors, background, typography.',
            'Изменения сохраняются автоматически. Вы всегда можете вернуться к предыдущему экрану.': 'Changes are saved automatically. You can always go back to the previous screen.',
            'Для каждого проекта доступна страница аналитики: просмотры, клики, конверсия по экранам. Перейдите в': 'Each project has an analytics page: views, clicks, conversion by screens. Go to',
            'и откройте «Аналитика» у нужного проекта.': 'and open "Analytics" for the required project.',
            'Как поделиться Mini App?': 'How to share a Mini App?',
            'Отправьте пользователям ссылку вида /app/PROJECT_ID или добавьте кнопку в вашем боте, открывающую WebApp.': 'Send users a link like /app/PROJECT_ID or add a button in your bot that opens the WebApp.',
            'Платно ли это?': 'Is it paid?',
            'Базовый тариф — бесплатно. Подробности в разделе': 'The basic plan is free. Details in the',
            'Наверх': 'Top',
            'Шаг {{n}}.': 'Step {{n}}.',
            'Создание бота и получение токена': 'Create a bot and get a token',
            'Создание бота и получение ключа': 'Create a bot and get a key',
            'Чтобы публиковать Mini App или подключать бота к проекту, нужен токен бота Telegram. Его выдаёт BotFather.': 'To publish a Mini App or connect a bot to a project, you need a Telegram bot token. It is issued by BotFather.',
            'Откройте': 'Open',
            'в Telegram': 'in Telegram',
            'Нажмите': 'Press',
            'и выберите': 'and choose',
            'Задайте имя бота (отображаемое имя) и уникальный юзернейм, оканчивающийся на': 'Set the bot name (display name) and a unique username ending with',
            'Задайте имя бота (отображаемое имя) и уникальный никнейм, оканчивающийся на': 'Set the bot name (display name) and a unique nickname ending with',
            '(например, MyShopAssistantBot)': '(for example, MyShopAssistantBot)',
            'Скопируйте выданный токен формата': 'Copy the issued token in the format',
            'Скопируйте выданный ключ формата': 'Copy the issued key in the format',
            '— он понадобится при создании проекта или подключении бота. Храните токен в секрете!': '— you will need it when creating a project or connecting a bot. Keep the token secret!',
            '— он понадобится при создании проекта или подключении бота. Храните его в секрете!': '— you will need it when creating a project or connecting a bot. Keep it secret!',
            'Никому не передавайте токен. При утечке сразу перевыпустите его через /revoke в BotFather.': 'Do not share the token with anyone. If it leaks, immediately revoke it via /revoke in BotFather.',
            'Никому не передавайте ключ (токен). При утечке сразу перевыпустите его через команду /revoke в BotFather.': 'Do not share the key (token) with anyone. If it leaks, immediately reissue it via the /revoke command in BotFather.',
            'Укажите токен бота на шаге создания проекта. Если токена нет —': 'Enter the bot token at the project creation step. If you don\'t have one —',
            'создайте бота и получите токен': 'create a bot and get a token',
            'Выберите элемент': 'Choose element',
            'Элементы': 'Elements',
            'Раздел пока пустой.': 'This section is empty.',
            'Добавьте первый элемент.': 'Add the first element.',
            'Открыть ссылку': 'Open link',
            'Запросить номер телефона': 'Request phone number',
            'Запросить геолокацию': 'Request location',
            'URL для открытия': 'URL to open',
            'Поле для телефона': 'Field for phone',
            'Поле для имени': 'Field for first name',
            'Запросить контакт': 'Request contact',
            'Поле для координат (lat,lon)': 'Field for coordinates (lat,lon)',
            'Поле для широты (lat)': 'Field for latitude (lat)',
            'Поле для долготы (lon)': 'Field for longitude (lon)',
            'В Telegram Mini Apps телефон запрашивается через разрешение пользователя. При отсутствии поддержки API запрос будет недоступен.': 'In Telegram Mini Apps, phone is requested through user permission. If API support is not available, the request will be unavailable.',
            'Если WebApp API недоступен, будет использована геолокация браузера (при наличии).': 'If WebApp API is unavailable, browser geolocation will be used (if available).',
            'Название обязательно': 'Name is required',
            'Сохранить товар': 'Save product',
            'Оплата недоступна: нет projectId': 'Payment unavailable: missing projectId',
            'Не удалось создать счёт': 'Failed to create invoice',
            'Платёжные провайдеры': 'Payment providers',
            'Добавьте токены сторонних платёжных сервисов. Храните токены в секрете.': 'Add third-party payment service tokens. Keep tokens secret.',
            'Имя провайдера': 'Provider name',
            'Например: yookassa': 'For example: yookassa',
            'Токен / ключ': 'Token / key',
            'Секретный ключ / токен API': 'Secret key / API token',
            'Пока не добавлено ни одного провайдера.': 'No providers have been added yet.',
            'Удалить провайдера': 'Delete provider',
            'Подключение платёжных провайдеров': 'Connecting payment providers',
            'Для приёма платежей в вашем боте нужно подключить платёжного провайдера через BotFather. Telegram поддерживает встроенные платежи через Telegram Stars (XTR) и внешних провайдеров (YooKassa, Stripe и др.).': 'To accept payments in your bot, you need to connect a payment provider via BotFather. Telegram supports built-in payments via Telegram Stars (XTR) and external providers (YooKassa, Stripe, etc.).',
            'Для приёма платежей в вашем боте нужно подключить платёжного провайдера через': 'To accept payments in your bot, you need to connect a payment provider via',
            'Telegram поддерживает:': 'Telegram supports:',
            'встроенные платежи через Telegram Stars (XTR)': 'built-in payments via Telegram Stars (XTR)',
            'внешние провайдеры (YooKassa, Stripe и др.)': 'external providers (YooKassa, Stripe, etc.)',
            'Telegram Stars (рекомендуется)': 'Telegram Stars (recommended)',
            'Для приёма платежей в Telegram Stars не требуется настройка провайдера — просто создайте товар с валютой XTR в настройках проекта.': 'To accept payments in Telegram Stars, no provider setup is required — just create a product with XTR currency in project settings.',
            'Для приёма платежей в Telegram Stars не требуется настройка провайдера.': 'No provider setup is required to accept payments in Telegram Stars.',
            'Просто создайте товар с валютой XTR в настройках проекта.': 'Just create a product with XTR currency in the project settings.',
            'Преимущества Telegram Stars:': 'Benefits of Telegram Stars:',
            'Самый простой способ начать принимать платежи': 'The easiest way to start accepting payments',
            'Без регистрации': 'No registration',
            'Без комиссий третьих лиц': 'No third-party fees',
            'Работает во всех странах': 'Works in all countries',
            'Telegram Stars — самый простой способ начать принимать платежи: без регистрации, без комиссий третьих лиц, работает во всех странах.': 'Telegram Stars is the easiest way to start accepting payments: no registration, no third-party fees, works in all countries.',
            'Подключение внешнего провайдера (YooKassa, Stripe и др.)': 'Connecting external provider (YooKassa, Stripe, etc.)',
            'Зарегистрируйтесь в платёжной системе': 'Register with a payment system',
            'для РФ, карты и кошельки': 'for Russia, cards and wallets',
            'Отправьте команду': 'Send command',
            'и выберите своего бота': 'and select your bot',
            'Выберите нужного провайдера из списка (например, YooKassa или Stripe)': 'Choose the desired provider from the list (e.g., YooKassa or Stripe)',
            'Следуйте инструкциям BotFather — обычно нужно ввести токен/ключ от платёжной системы': 'Follow BotFather instructions — usually you need to enter a token/key from the payment system',
            'Следуйте инструкциям BotFather — обычно нужно ввести ключ (токен) от платёжной системы': 'Follow BotFather instructions — usually you need to enter a key (token) from the payment system',
            'После подключения BotFather выдаст вам': 'After connecting, BotFather will give you',
            '(формат: ': '(format: ',
            'Скопируйте Provider Token и добавьте его в настройках вашего проекта': 'Copy the Provider Token and add it in your project settings',
            'откройте проект': 'open project',
            'введите имя провайдера (например, yookassa) и вставьте токен': 'enter provider name (e.g., yookassa) and paste the token',
            'введите имя провайдера ': 'enter provider name ',
            '(например, yookassa) и вставьте токен': '(e.g., yookassa) and paste the token',
            '(например, yookassa) и вставьте ключ': '(e.g., yookassa) and paste the key',
            'Для тестирования используйте тестовые токены (содержат :TEST:). Для приёма реальных платежей замените на боевой токен.': 'For testing, use test tokens (contain :TEST:). For real payments, replace with a production token.',
            'Для тестирования используйте тестовые токены (содержат :TEST:).': 'For testing, use test tokens (contain :TEST:).',
            'Для тестирования используйте тестовые ключи (содержат :TEST:).': 'For testing, use test keys (contain :TEST:).',
            'Для приёма реальных платежей замените на боевой токен.': 'For real payments, replace with a production token.',
            'Для приёма реальных платежей замените на боевой ключ (токен).': 'For real payments, replace with a production key (token).',
            'NOWPayments (крипто‑платежи)': 'NOWPayments (crypto payments)',
            'NOWPayments (криптовалютные платежи)': 'NOWPayments (cryptocurrency payments)',
            'Зарегистрируйтесь в': 'Register at',
            'и получите': 'and get',
            '(в разделе Payment Settings)': '(in the Payment Settings section)',
            'проекта': 'project',
            'и заполните блок': 'and fill the block',
            'поля': 'fields',
            'и': 'and',
            'Безопасность: IPN подписывается заголовком': 'Security: IPN is signed with the header',
            '(HMAC‑SHA512 от отсортированного JSON) по вашему': '(HMAC-SHA512 of sorted JSON) using your',
            'Подпись проверяется на бэкенде.': 'The signature is verified on the backend.',
            'Подпись проверяется на бэкэнде.': 'The signature is verified on the backend.',
            'BotFather': 'BotFather',
            'Создание товара с провайдером': 'Creating a product with provider',
            'Откройте настройки проекта и убедитесь, что провайдер добавлен': 'Open project settings and make sure the provider is added',
            'Перейдите в раздел': 'Go to section',
            'Товары': 'Products',
            'Добавить товар': 'Add product',
            'Заполните название, описание, цену и выберите валюту (RUB, USD, EUR или XTR)': 'Fill in the name, description, price and select currency (RUB, USD, EUR or XTR)',
            'В поле «Провайдер» выберите подключенного провайдера (для XTR провайдер не нужен)': 'In the "Provider" field, select a connected provider (no provider needed for XTR)',
            'Сохраните товар — он станет доступен для покупки в боте': 'Save the product — it will become available for purchase in the bot',
            'Храните Provider Token в секрете! Не передавайте его третьим лицам.': 'Keep the Provider Token secret! Do not share it with third parties.',
            'Или создайте бота в мини-приложении BotFather': 'Or create a bot in BotFather MiniApp',
            'Заполните название, описание, цену и выберите валюту (RUB, USD или XTR)': 'Fill in the name, description, price and select currency (RUB, USD or XTR)',
            'Конструктор мини приложений': 'Mini app constructor',
            'Разблокировать все функции': 'Unlock all features',
            'Подключить премиум': 'Connect premium',
            'Ссылка на приложение': 'App link',
            'Если не получилось авторизоваться, попробуйте перейти по ': 'If authorization failed, try via ',
            'ссылке': 'link',
            'Поделиться': 'Share',
            'Скопировано': 'Copied',
            'Структура приложения': 'App structure',
            'Блоки': 'Blocks',
            'Меню': 'Menu',
            'Тема': 'Theme',
            'Просмотр приложения': 'App preview',
            'Подключить к бизнес боту': 'Connect to business bot',
            'Уведомления': 'Notifications',
            'Инструкции': 'Guides',
            'Новости': 'News',
            'Мои приложения': 'My apps',
            'Создать мини приложение': 'Create Mini App',
            'Настройки': 'Settings',
            'Удалить проект?': 'Delete project?',
            'Вы действительно хотите удалить этот проект? Это действие необратимо.': 'Are you sure you want to delete this project? This action is irreversible.',
            'Лимит достигнут': 'Limit reached',
            'Вы достигли лимита проектов по вашему тарифу. Обновите тариф, чтобы создать больше.': 'You have reached the project limit for your plan. Upgrade to create more.',
            'Провайдер обязателен для выбранной валюты': 'Provider is required for selected currency',
            'Провайдер не настроен в проекте': 'Provider is not configured in the project',
            'Провайдер оплаты': 'Payment provider',
            'Нет настроенных провайдеров': 'No configured providers',
            'Список полей': 'Field list',
            'Метка (Label)': 'Label',
            'Нет полей': 'No fields',
            paid: 'Paid',
            failed: 'Failed',
            pending: 'Pending',
            'Заказы': 'Orders',
            'Заказ': 'Order',
            'Клиент': 'Client',
            'Нет заказов': 'No orders',
            'Пока нет товаров': 'No products yet',
            'Удалить товар?': 'Delete product?',
            'Вы действительно хотите удалить': 'Are you sure you want to delete',
            'Telegram Stars': 'Telegram Stars',
            'Графики': 'Charts',
            'Дата "От" позже даты "До"': 'The "From" date is later than the "To" date',
            'Максимум 90 дней': 'Maximum 90 days',
            'Способ оплаты': 'Payment method',
            'Загрузка...': 'Loading...',
            'Включить уведомления': 'Enable notifications',
            'Страница в разработке': 'Page under construction',
            'Мы активно работаем над этим продуктом. А пока все возможности доступны в нашем мини-приложении.': 'We are actively working on this product. Meanwhile, all features are available in our mini app.',
            'прямо сейчас!': 'right now!',
            'Переходите': 'Go to',
            'Перейти в приложение': 'Go to app',
            'Уведомления отправляются в ваш Telegram от имени привязанного бота (например, о новых оплатах).': 'Notifications are sent to your Telegram on behalf of the linked bot (for example, about new payments).',
            'Сохранение...': 'Saving...',
            'Название не может быть пустым': 'Name cannot be empty',
            'Выбрать товар': 'Select product',
            'Новый товар': 'New product',
            'Создать новый товар': 'Create new product',
            'Редактировать товар': 'Edit product',
            'Курс звезд': 'Stars rate',
            '1 звезда =': '1 star =',
            'Данные доступа': 'Access credentials',
            'Изменить': 'Edit',
            'Провайдеры': 'Providers',
            'Провайдеры отсутствуют': 'No providers',
            'Token': 'Token',
            'Секретный токен провайдера': 'Provider secret token',
            'Добавить провайдера': 'Add provider',
            'Название провайдера': 'Provider name',
            'например, yookassa': 'e.g., yookassa',
            'Секретный ключ NOWPayments': 'NOWPayments secret key',
            'Другие': 'Others',
            'TgStars': 'TgStars',
            'Crypto': 'Crypto',
            'Что это': 'What is it',
            'Как использовать': 'How to use',
            'Важно': 'Important',
            'Включите переключатель, чтобы принимать оплату звёздами.': 'Turn on the toggle to accept payments with stars.',
            'Укажите курс: сколько {{currency}} соответствует 1 звезде.': 'Specify the rate: how much {{currency}} equals 1 star.',
            'Цены товаров будут пересчитываться по указанному курсу.': 'Product prices will be recalculated using the specified rate.',
            'Курс влияет только на отображение цен и итог расчёта для пользователя.': 'The rate only affects the display of prices and the calculation total for the user.',
            'Комиссии платформы учитывайте самостоятельно при формировании цен.': 'Consider platform fees yourself when setting prices.',
            'NOWPayments — провайдер крипто‑платежей с IPN (webhook) для подтверждения.': 'NOWPayments is a crypto payments provider with IPN (webhook) for confirmation.',
            'Как подключить': 'How to connect',
            'Включите переключатель провайдера.': 'Enable the provider toggle.',
            '«Изменить»': '"Edit"',
            'и вставьте': 'and paste',
            'из кабинета NOWPayments.': 'from the NOWPayments dashboard.',
            'Нажмите «Изменить» и вставьте API Key и IPN Secret из кабинета NOWPayments.': 'Click "Edit" and paste the API Key and IPN Secret from the NOWPayments dashboard.',
            'Сохраните — ключи будут скрыты и отображаться в маске.': 'Save — the keys will be hidden and displayed masked.',
            'Подсказки': 'Tips',
            'Примечание': 'Note',
            'Этот метод не позволяет формировать чеки, поэтому не подходит для работы с картами РФ.': 'This method does not allow issuing receipts, so it is not suitable for cards in the Russian Federation.',
            'Убедитесь, что IPN включён в настройках NOWPayments.': 'Make sure IPN is enabled in NOWPayments settings.',
            'Сохраните IPN где-нибудь, его можно прочитать только 1 раз.': 'Save the IPN somewhere; it can be viewed only once.',
            'Мы автоматически обработаем статусы платежей по IPN.': 'We will automatically handle payment statuses via IPN.',
            '⚠️ Примечание: Этот метод не позволяет формировать чеки, поэтому не подходит для работы с картами РФ.': '⚠️ Note: This method does not allow issuing receipts, so it is not suitable for cards in the Russian Federation.',
            'Подключение кассы через Bot Payments API:': 'Connecting a cashier via Bot Payments API:',
            'Перейдите в': 'Go to',
            'отправьте ему команду /mybots и выберите вашего бота.': 'send the /mybots command and choose your bot.',
            'Зайдите в': 'Open',
            'Вернитесь в': 'Return to',
            'В подключённых кассах будет указан токен, скопируйте его.': 'A token will appear in the connected providers; copy it.',
            '«Добавить провайдер»': '"Add provider"',
            'и введите имя провайдера и токен.': 'and enter the provider name and token.',
            'Перейдите в @BotFather, отправьте ему команду /mybots и выберите вашего бота.': 'Go to @BotFather, send the /mybots command and choose your bot.',
            'Зайдите в Bot Settings - Payments': 'Open Bot Settings — Payments',
            'Выберите кассу из списка, вас перенаправит на бота этой кассы.': 'Select a provider from the list; you will be redirected to its bot.',
            'Заполните данные, необходимые для этой кассы.': 'Fill in the data required by this provider.',
            'Вернитесь в @BotFather. В подключённых кассах будет указан токен, скопируйте его.': 'Return to @BotFather. A token will appear in the connected providers; copy it.',
            'Нажмите "Добавить провайдер" и введите имя провайдера и токен.': 'Click "Add provider" and enter the provider name and token.',
            '1. Перейдите в @BotFather, отправьте ему команду /mybots и выберите вашего бота.': '1. Go to @BotFather, send the /mybots command and choose your bot.',
            '2. Зайдите в Bot Settings - Payments': '2. Open Bot Settings — Payments',
            '3. Выберите кассу из списка, вас перенаправит на бота этой кассы.': '3. Select a provider from the list; you will be redirected to its bot.',
            '4. Заполните данные, необходимые для этой кассы.': '4. Fill in the data required by this provider.',
            '5. Вернитесь в @BotFather. В подключённых кассах будет указан токен, скопируйте его.': '5. Return to @BotFather. A token will appear in the connected providers; copy it.',
            '6. Нажмите "Добавить провайдер" и введите имя провайдера и токен.': '6. Click "Add provider" and enter the provider name and token.',
            'Скопируйте и вставьте эту ссылку в BotFather как WebApp URL для основного приложения (Main App).': 'Copy and paste this link into BotFather as the WebApp URL for the main application (Main App).',
            'Telegram Stars — это внутренняя валюта Telegram для оплаты в мини‑приложениях.': 'Telegram Stars is the internal currency of Telegram for payments in mini apps.',
            'IPN Secret из настроек NOWPayments': 'IPN Secret from NOWPayments settings',
            'Добавление...': 'Adding...',
            'Раздел новостей скоро появится.': 'The news section will appear soon.',
            'Настройки приложения': 'App settings',
            'Настройки темы': 'Theme settings',
            'Настройка магазина': 'Shop settings',
            'Для привязки бота требуется токен.': 'A token is required to link the bot.',
            'Бот успешно привязан': 'Bot linked successfully',
            'Ошибка привязки бота': 'Bot linking error',
            'Привязка...': 'Linking...',
            'Привязать': 'Link',
            'Раздел #{{n}}': 'Section #{{n}}',
            'Добавить раздел': 'Add section',
            'Подключение внешнего провайдера (YooKassa и др.)': 'Connecting external provider (YooKassa, etc.)',
            'Тема приложения': 'App theme',
            'Использовать тему Telegram': 'Use Telegram theme',
            'Тема берется из Telegram': 'Theme is taken from Telegram',
            'Настроить свою тему': 'Customize your theme',
            'Вы сможете выбрать цвета': 'You will be able to choose colors',
            'Фон приложения': 'App background',
            'Цвет фона': 'Background color',
            'Вторичный фон': 'Secondary background',
            'Основной текст': 'Primary text',
            'Вторичный текст': 'Secondary text',
            'Цвет кнопки': 'Button color',
            'Фон элементов': 'Elements background',
            'Текст основной': 'Primary text',
            'Текст вторичный': 'Secondary text',
            'Откройте @BotFather': 'Open @BotFather',
            'Запустите и создайте бота': 'Start and create a bot',
            'Задайте имя и юзернейм': 'Set name and username',
            'Задайте имя и никнейм (username)': 'Set name and nickname (username)',
            'Скопируйте токен бота': 'Copy the bot token',
            'Скопируйте ключ (токен) бота': 'Copy the bot key (token)',
            'Чтобы публиковать Mini App, нужен токен бота Telegram. Его выдаёт BotFather.': 'To publish a Mini App, you need a Telegram bot token. It is issued by BotFather.',
            'Чтобы публиковать приложение, нужен ключ (токен) бота Telegram. Его выдаёт BotFather.': 'To publish an app, you need a bot key (token) from Telegram. It is issued by BotFather.',
            'Таблица': 'Table',
            'Открытия Web App': 'WebApp opens',
            'Заявки': 'Submissions',
            'Конверсия': 'Conversion',
            '7 дней': '7 days',
            '14 дней': '14 days',
            '30 дней': '30 days',
            'API Key': 'API Key',
            'IPN Secret': 'IPN Secret',
            'Бизнес': 'Business',
            'Постинг': 'Posting',
            'бизнес': 'business',
            'постинг': 'posting',
            'Сообщить об ошибке': 'Report an error',
            'Опишите проблему': 'Describe the problem',
            'Добавить файлы': 'Add files',
            'Бета-версия': 'Beta version',
            'Мы еще дорабатываем продукт': 'We are still working on the product',
            'Открыть': 'Open',
            'Вы достигли лимита проектов по вашему тарифу. Обновите тариф, чтобы создать больше': 'You have reached the limit of projects for your tariff. Update your tariff to create more.',
            'Тут пока ничего нет': 'There is nothing here yet',
            'Эта ссылка предназначена для работы внутри Telegram-ботов в формате': 'This link is intended for use inside Telegram bots as',
            'выберите бота и зайдите в настройки': 'select a bot and go to settings',
            'Вы можете использовать эту ссылку в': 'You can use this link in',
            'и для создания': 'and to create a',
            'Если у вас есть товары в приложении, то обязательно привязать бота кнопкой': 'If you have products in the app, you must connect the bot with the',
            'что в свою очередь переопределить кнопку меню для открытия': 'which in turn will override the menu button to open',
            'Как использовать эту ссылку': 'How to use this link',
            'Сетка': 'Grid',
            'Мои бизнес боты': 'My business bots',
            'Мои постинг боты': 'My posting bots',
            'Имя бота': 'Bot name',
            'Тип': 'Type',
            'Отключен': 'Disabled',
            'Бесплатно': 'Free',
            'Оплатить': 'Pay',
            'Оплата Fleep.бизнес': 'Payment for Fleep.business',
            'Оплата Fleep.постинг': 'Payment for Fleep.posting',
            'Оплата Флип.бизнес': 'Payment for Fleep.business',
            'Оплата Флип.постинг': 'Payment for Fleep.posting',
            'Флип.бизнес': 'Fleep.business',
            'Флип.постинг': 'Fleep.posting',
            'Флип.': 'Fleep.',
            'Оплата баланса': 'Balance top-up',
            'Что нужно оплатить': 'What to pay for',
            'Fleep.бизнес': 'Fleep.business',
            'Fleep.постинг': 'Fleep.posting',
            'Баланс': 'Balance',
            'Выберите период': 'Select period',
            'дней': 'days',
            'Использовать средства с баланса?': 'Use balance funds?',
            'Итого к оплате': 'Total to pay',
            'Создание…': 'Creating...',
            'Выберите канал': 'Select channel',
            'Каналы': 'Channels',
            'Выбрано': 'Selected',
            'Сумма пополнения': 'Top-up amount',
            'Введите сумму': 'Enter amount',
            'до 15 августа': 'until August 15',
            'Выбранные боты': 'Selected bots',
            'Очистить всё': 'Clear all',
            'Выберите тариф': 'Select tariff',
            'только что': 'just now',
            'мин назад': 'min ago',
            'до': 'until',
            'Выбрать все': 'Select all',
            'Сбросить все': 'Clear all',
            'Нет доступных каналов': 'No channels available',
            'Дата окончания': 'End date',
            'Истекла': 'Expired',
            'Закончится через {{days}} дн.': 'Expires in {{days}} days',
            '{{days}} дн.': '{{days}} d.',
            'через {{days}} дн.': 'in {{days}} days',
            'Бизнес боты': 'Business bots',
            'Постинг боты': 'Posting bots',
            'приложения': 'apps',
            'Войти как {{name}}': 'Login as {{name}}',
            'Главная': 'Main',
            'Сделать главной': 'Make main',
            'Сделать главным': 'Make main',
            'Сделать главным экраном': 'Make main screen',
            'Переместить этот экран в начало списка?': 'Move this screen to the start of the list?',
            'Статус': 'Status',
            'Включен': 'On',
            'Выключен': 'Off',
            'Включено автопродление': 'Autorenewal enabled',
            'В этом разделе пока нет активных ботов.': 'No active bots in this section.',
            'В этом разделе пока нет приложений.': 'No apps in this section.',
            'Не удалось загрузить ботов': 'Failed to load bots',
            'Окончание подписки': 'Subscription end',
            'тариф': 'tariff',
            'Загрузка…': 'Loading...',
            'Email': 'Email',
            'Автоплатеж': 'Recurrent payment',
            'Введите email': 'Enter email',
            'Введите промокод': 'Enter promo code',
            'Выбрано: ': 'Selected: ',
            'Выбрать': 'Select',
            'Использовать средства с баланса': 'Use balance funds',
            'Итого': 'Total',
            'Неверный промокод': 'Invalid promo code',
            'Некорректный email': 'Invalid email',
            'Промокод': 'Promo code',
            'Каналы для постинга': 'Channels for posting',
            'Скрыть': 'Hide',
            'Выбрать все каналы': 'Select all channels',
            'Выберите каналы': 'Select channels',
            'Оплата прошла успешно!': 'Payment successful!',
            'Вы успешно оплатили тариф': 'You have successfully paid for the',
            'на': 'plan for',
            'Дата окончания подписки:': 'Subscription end date:',
            'Вы не можете понизить уровень вашего тарифа': 'You cannot downgrade your tariff',
            'Сайт:': 'Site:',
            'Флип бот:': 'Fleep bot:',
            'Партнёрская программа Флип': 'Fleep Affiliate Program',
            'Приглашайте коллег, друзей и знакомых в сервис Флип': 'Invite colleagues, friends and acquaintances to Fleep',
            'и получайте 50% от суммы каждого их платежа на ваш партнёрский баланс.': 'and receive 50% of each of their payments to your affiliate balance.',
            'Стать партнёром': 'Become a partner',
            'Авторизуйтесь через Telegram.': 'Log in via Telegram.',
            'Поделитесь вашей персональной реферальной ссылкой или готовым креативом.': 'Share your personal referral link or ready-made creative.',
            'Ваш друг регистрируется по вашей ссылке.': 'Your friend signs up using your link.',
            'На ваш счёт зачисляется': 'Your account is credited with',
            '50% от всех его платежей': '50% of all their payments',
            'в будущем.': 'in the future.',
            'Приглашённый друг оплатил годовую подписку — вы получаете бонус, равный стоимости 6 месяцев!': 'An invited friend paid for an annual subscription — you get a bonus equal to 6 months!',
            'Как это работает?': 'How does it work?',
            'Как использовать бонусы?': 'How to use bonuses?',
            'Партнёрский баланс можно применить при оплате любой услуги во Флип:': 'Affiliate balance can be applied when paying for any Fleep service:',
            'Полная оплата подписки': 'Full subscription payment',
            'Когда сумма бонусов превышает или равна стоимости выбранного тарифа.': 'When the bonus amount exceeds or equals the cost of the selected plan.',
            'Частичная оплата': 'Partial payment',
            'Если баланса не хватает на всю подписку, то можно оплатить только часть, остаток — другим способом.': 'If the balance is not enough for the full subscription, you can pay only part, the rest — by another method.',
            'Оплата Telemetr': 'Telemetr payment',
            'Подписка сроком до 1 года на': 'Subscription for up to 1 year on',
            'Правила программы': 'Program rules',
            'Разрешено': 'Allowed',
            'Делиться ссылкой лично в соцсетях, мессенджерах, блогах или на собственных сайтах.': 'Share the link personally on social media, messengers, blogs or your own websites.',
            'Использовать готовые рекламные материалы Флип.Бизнес и Флип.Постинг.': 'Use ready-made promotional materials from Fleep.Business and Fleep.Posting.',
            'Использовать готовые': 'Use ready-made',
            'рекламные материалы': 'promotional materials',
            'Флип.Бизнес и Флип.Постинг.': 'from Fleep.Business and Fleep.Posting.',
            'Приглашать реальных знакомых, заинтересованных в сервисе.': 'Invite real acquaintances who are interested in the service.',
            'Запрещено': 'Forbidden',
            'Рассылать ссылку без согласия получателей.': 'Send the link without the recipients\' consent.',
            'Размещать реферальные ссылки в платных рекламных кампаниях.': 'Place referral links in paid advertising campaigns.',
            'Размещать реферальные ссылки в скрытом виде (iframe, redirect и т.д.).': 'Place referral links in hidden form (iframe, redirect, etc.).',
            'Создавать аккаунты или регистрироваться по своим же реферальным ссылкам. Это приведёт к блокировке.': 'Create accounts or sign up using your own referral links. This will result in a ban.',
            'Присоединяйтесь к программе': 'Join the program',
            'и делитесь преимуществами Флип с другими!': 'and share the benefits of Fleep with others!',
            'Партнёрские ссылки': 'Affiliate links',
            'Сайт': 'Site',
            'Флип бот': 'Fleep bot',
            'Регистраций': 'Registrations',
            'Оплат': 'Payments',
            'Партнёрский процент': 'Affiliate percentage',
            'Оплатить Флип': 'Pay for Fleep',
            'Оплатить Telemetr': 'Pay for Telemetr',
            'Авторизуйтесь': 'Log in',
            'через Telegram.': 'via Telegram.',
            'Флип': 'Fleep',
            'Добавить элемент в Форму': 'Add element to Form',
            'Добавить в товары': 'Add to products',
            'Добавить в контейнер': 'Add to container',
            'Вернуться на главный экран': 'Return to main screen',
            'Бот не опубликован.': 'Bot is not published.',
            'Настройка приложения': 'App settings',
            'Редактировать приложение': 'Edit app',
            'Магазин': 'Shop',
            'Статистика': 'Statistics',
            'Мини-приложение': 'Mini app',
            'Название мини-приложения': 'Mini app name',
            'Привязка бота': 'Bot linking',
            'Свернуть': 'Collapse',
            'Развернуть': 'Expand',
            'Добавьте ID чатов, в которые хотите получать уведомления': 'Add chat IDs where you want to receive notifications',
            'о новых заказах и заполненных формах. Вы можете указать несколько ID через точку с запятой.': 'about new orders and filled forms. You can specify multiple IDs separated by semicolons',
            'Если поле оставить пустым, уведомления будут отправляться владельцу приложения.': 'If the field is left empty, notifications will be sent to the app owner.',
            'Уведомление о заказах': 'Order notifications',
            'Уведомление о формах': 'Form notifications',
            'Можно указать несколько ID через точку с запятой': 'You can specify multiple IDs separated by semicolons',
            'Используйте формат: -1001234567890 или 123456789': 'Use format: -1001234567890 or 123456789',
            'Используйте формат: -1001234567890; 123456789': 'Use format: -1001234567890; 123456789',
            'Кассы': 'Payment systems',
            'Визуализация приложения': 'App visualization',
            'Статус приложения': 'App status',
            'Активно': 'Active',
            'Отключено': 'Disabled',
            'Приложение доступно пользователям.': 'App is available to users.',
            'Приложение отключено. Активируйте его, чтобы получить доступ к настройкам.': 'App is disabled. Activate it to access settings.',
            'Приложение отключено. Оплатите подписку, чтобы получить доступ к настройкам.': 'App is disabled. Pay subscription to access settings.',
            'Оплатить подписку': 'Pay subscription',
            'Выберите валюту магазина': 'Select store currency',
            'Прием платежей': 'Accept payments',
            'Курс': 'Rate',
            'Криптовалюта (NowPayments)': 'Cryptocurrency (NowPayments)',
            'Секретный ключ': 'Secret key',
            'Нижний колонтитул мини-приложения': 'Mini app footer',
            '-1001234567890; 123456789': '-1001234567890; 123456789',
            'Бот не подключен': 'Bot not connected',
            'Подключить': 'Connect',
            'Просмотры и отправки форм': 'Views and form submissions',
            'Экспорт': 'Export',
            'Таблица отправок форм': 'Form submissions table',
            'У вас пока нет товаров': 'You have no products yet',
            'Добавить первый товар': 'Add first product',
            'Вы уверены, что хотите удалить товар': 'Are you sure you want to delete product',
            'Товар будет удалён без возможности восстановления.': 'The product will be deleted permanently.',
            'Тарифы Флип.Приложения': 'Fleep.Apps Pricing',
            'Просто посмотреть': 'Just look',
            'Для знакомства с возможностями': 'To get acquainted with the features',
            'Полный функционал конструктора': 'Full constructor functionality',
            '2 приложения': '2 apps',
            'Уже нравится': 'Already like it',
            'Для первого проекта': 'For the first project',
            'Безлимитное количество приложений': 'Unlimited number of apps',
            'Самый выгодный': 'Most profitable',
            'Это любовь': 'This is love',
            'Для неограниченного роста': 'For unlimited growth',
            '/ 2 недели': '/ 2 weeks',
            '/ месяц': '/ month',
            'Попробовать бесплатно': 'Try for free',
            'при оплате за 12 месяцев': 'when paying for 12 months',
            'Оплатите тариф что бы продолжить пользоваться приложением.': 'Pay the tariff to continue using the application.',
            'Откройте все возможности': 'Unlock all possibilities',
            'Доступные функции и цены для любых задач. Подберите план, который идеально вам подходит.': 'Available features and prices for any task. Choose the plan that\'s perfect for you.',
            'Смотреть тарифы': 'View tariffs',
            'Настройки приложения недоступны': 'App settings unavailable',
            'Активируйте приложение с помощью переключателя выше, чтобы получить доступ к настройкам': 'Activate the app using the toggle above to access settings',
            'Тарифные планы': 'Tariff plans',
            'Первые 14 дней у нас действует бесплатный период, чтобы вы могли оценить все возможности.': 'For the first 14 days we have a free period so you can evaluate all the features.',
            'После пробного периода стоимость составляет:': 'After the trial period the cost is:',
            'При помесячной оплате': 'With a monthly payment',
            '₽/мес': '₽/month',
            'При оплате сразу за год': 'When paying for the whole year',
            'Приглашайте коллег, друзей и знакомых': 'Invite colleagues, friends and acquaintances',
            'Больше не спрашивать': "Don't ask again",
            'Доступно для копирования': 'Available for copying',
            'Ссылка': 'Link',
            'Неверный логин или пароль': 'Invalid login or password',
            'Пароли не совпадают': 'Passwords do not match',
            'Логин уже занят': 'Login already taken',
            'Не удалось пройти проверку капчи': 'Captcha verification failed',
            'Капча не настроена': 'Captcha is not configured',
            'Не удалось зарегистрироваться': 'Registration failed',
            'Не удалось войти': 'Login failed',
            'Подтвердите, что вы не робот': 'Please confirm you are not a robot',
            'Необходимо согласие с условиями': 'You must agree to the terms',
            'Авторизация': 'Sign in',
            'Регистрация': 'Sign up',
            'Логин': 'Login',
            'Введите логин': 'Enter login',
            'Минимум 3 символа': 'At least 3 characters',
            'Максимум 64 символа': 'Maximum 64 characters',
            'Введите пароль': 'Enter password',
            'Минимум 8 символов': 'At least 8 characters',
            'Максимум 128 символов': 'Maximum 128 characters',
            'Показать пароль': 'Show password',
            'Скрыть пароль': 'Hide password',
            'Подтверждение пароля': 'Confirm password',
            'Повторите пароль': 'Repeat password',
            'Зарегистрироваться': 'Sign up',
            authRegisterConsent: 'By clicking the button below, you agree to the <agreement>User Agreement</agreement>, <privacy>Privacy Policy</privacy> and <offer>Offer</offer>.',
            'Капча не настроена (dev-режим)': 'Captcha is not configured (dev mode)',
            'Неверный client key: нужен ключ с префиксом ysc1_ из Yandex SmartCaptcha': 'Invalid client key: use a ysc1_ key from Yandex SmartCaptcha',
        },
    },
    ru: {
        translation: {
            ...pricing.ru,
            ...greeting.ru,
            ...landing.ru,
            planMessage: 'У вас осталось {{projectsLength}}/{{maxApps}} Mini Apps',
            text: 'Текст',
            input: 'Инпут',
            button: 'Кнопка',
            image: 'Картинка',
            select: 'Выбор',
            datetime: 'Дата и время',
            product: 'Товар',
            form: 'Форма',
            radiobutton: 'Переключатель',
            checkbox: 'Чекбокс',
            products: 'Товары',
            container: 'Контейнер',
            APP_OPEN: 'Открытие приложения',
            SCREEN_VIEW: 'Просмотр экрана',
            BUTTON_CLICK: 'Клик по кнопке',
            FORM_SUBMIT: 'Отправка формы',
            paid: 'Оплачено',
            failed: 'Отменено',
            pending: 'Ожидание',
            'Тарифы Флип.Приложения': 'Тарифы Флип.Приложения',
            'Просто посмотреть': 'Просто посмотреть',
            'Для знакомства с возможностями': 'Для знакомства с возможностями',
            'Полный функционал конструктора': 'Полный функционал конструктора',
            '2 приложения': '2 приложения',
            'Уже нравится': 'Уже нравится',
            'Для первого проекта': 'Для первого проекта',
            'Безлимитное количество приложений': 'Безлимитное количество приложений',
            'Самый выгодный': 'Самый выгодный',
            'Это любовь': 'Это любовь',
            'Для неограниченного роста': 'Для неограниченного роста',
            'при оплате за 12 месяцев': 'при оплате за 12 месяцев',
            'Оплатите тариф что бы продолжить пользоваться приложением.': 'Оплатите тариф что бы продолжить пользоваться приложением.',
            'Откройте все возможности': 'Откройте все возможности',
            'Доступные функции и цены для любых задач. Подберите план, который идеально вам подходит.': 'Доступные функции и цены для любых задач. Подберите план, который идеально вам подходит.',
            'Выбрать тариф': 'Выбрать тариф',
            authRegisterConsent: 'Нажимая кнопку ниже, вы соглашаетесь с <agreement>Пользовательским соглашением</agreement>, <privacy>Политикой конфиденциальности</privacy> и <offer>Офертой</offer>.',
        }
    }
};

i18n.use(initReactI18next).init({
    resources,
    lng: localStorage.getItem('i18nLng') || 'ru',
    interpolation: { escapeValue: false },
});

export default i18n;
